module.exports = __webpack_public_path__ + "img/WaldMC.ad87e3a0.png";